<script>
  import File from '@components/List/File'

  export default {
    components: { File },
    props: {
      list: {
        type: Array,
        default: () => {
          return [
            {
              title: '股東會年報',
              alias: 'stockyear',
              items: [
                {
                  title: '108年度年報(股東會)',
                  file: 'test.pdf',
                },
                {
                  title: '106年度年報(股東會)',
                  file: 'test.pdf',
                },
                {
                  title: '105年度年報(股東會)',
                  file: 'test.pdf',
                },
                {
                  title: '103年度年報(股東會)',
                  file: 'test.pdf',
                }
              ]
            },
            {
              title: '股東會開會通知',
              alias: 'stocknotice',
              items: [
                {
                  title: '108年度股東會開會通知',
                  file: 'test.pdf',
                },
                {
                  title: '106年度股東會開會通知',
                  file: 'test.pdf',
                },
                {
                  title: '105年度股東會開會通知',
                  file: 'test.pdf',
                },
                {
                  title: '103年度股東會開會通知',
                  file: 'test.pdf',
                }
              ]
            },
            {
              title: '股東會議事手冊',
              alias: 'stockmetting',
              items: [
                {
                  title: '108年度股東會議事手冊',
                  file: 'test.pdf',
                },
                {
                  title: '106年度股東會議事手冊',
                  file: 'test.pdf',
                },
                {
                  title: '105年度股東會議事手冊',
                  file: 'test.pdf',
                },
                {
                  title: '103年度股東會議事手冊',
                  file: 'test.pdf',
                }
              ]
            },
            {
              title: '股東會議事錄',
              alias: 'stockwrite',
              items: [
                {
                  title: '108年度股東會議事錄',
                  file: 'test.pdf',
                },
                {
                  title: '106年度股東會議事錄',
                  file: 'test.pdf',
                },
                {
                  title: '105年度股東會議事錄',
                  file: 'test.pdf',
                },
                {
                  title: '103年度股東會議事錄',
                  file: 'test.pdf',
                }
              ]
            }
          ]
        }
      }
    },
    data() {
      return {
        activeMenu: '股東會年報'
      }
    },
  }
</script>
<template>
  <section :class="$style.sectionFile" class="section">
    <div class="container">
      <BaseSectionTitle
        title="文件項目"
        class="text-center"
      />
      <div class="d-block d-md-none mb-5">
        <el-select
          v-model="activeMenu"
          class="isStyleMenu isCenter"
          popper-class="isStyleMenu isCenter"
        >
          <el-option
            v-for="(item, index) in list"
            :key="item.title"
            :label="item.title"
            :value="item.alias">
          </el-option>
        </el-select>
      </div>
      <el-tabs
        v-model="activeMenu"
        stretch
        class="isStyleBase"
      >
        <el-tab-pane
          v-for="(item,$index) in list"
          :key="$index"
          :label="item.title"
          :name="item.alias"
        >
          <div v-if="item.items.length" class="row sectionFile__list">
            <div
              v-for="(value,$index2) in item.items"
              :key="$index2"
              class="col-md-4"
            >
              <File :item="value" class="sectionFile__item"/>
            </div>
          </div>
          <div v-else class="text-center">
            <h5>暫無資料</h5>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </section>
</template>
<style lang="scss" module>
  .sectionFile {
    background: $color-gray-2;

    :global {
      .sectionFile {
        &__list {
          margin-top: -40px;
        }

        &__item {
          height: 55px;
          padding: 0 18px;
          margin-top: 40px;
          line-height: 55px;
          color: $color-primary;
          text-decoration: none;
          background-color: #FFF;
          border: 2px solid rgba(226, 228, 232, 1);
          border-radius: 5px;
          transition: .3s;

          .icon {
            font-size: 28px;
          }

          .title {
            font-size: 1rem;
            transition: .3s;
          }

          &:hover {
            border-color: $color-primary-hover;

            .title {
              color: $color-primary-hover;
            }
          }
        }
      }

      .el-tabs__header {
        @include max-md {
          display: none;
        }
      }
    }
  }
</style>
